export default __webpack_public_path__ + "static/media/feather_plus.ab4d9c36.svg";